import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ILicenseQuestion } from 'app/models/licenses/license-question';

@Injectable({ providedIn: 'root' })
export class QuestionService {
  private api: string = environment.privateApi + 'Questions/';

  private http = inject(HttpClient);

  public getLicenseQuestions(licenseMasterId: number): Observable<ILicenseQuestion[]> {
    return this.http.get<ILicenseQuestion[]>(this.api + 'GetLicenseQuestions/' + licenseMasterId);
  }

  public getQuestions(): Observable<ILicenseQuestion[]> {
    return this.http.get<ILicenseQuestion[]>(this.api + 'GetQuestions');
  }

  public updateLicenseQuestions(licenseQuestions: ILicenseQuestion[]): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateLicenseQuestions', licenseQuestions);
  }
}
